<template>
  <div>
    <div ref="modal" style="display: none">

      <div class="mb-3">
        <b>Отчёт по платежам детальный</b>
      </div>
      <a href="#"></a>
      <gui-input-date-range v-model="filter" fromKey="dateFrom" toKey="dateTo" label="Дата вызова"/>
      <gui-organization-select v-model="filter.organizationId" label="Организация"/>

      <div class="mt-3">
        <button class="btn btn-success mr-2" @click.prevent="download">
          Скачать
        </button>
        <button class="btn btn-secondary" @click.prevent="fancyboxClose()">
          Отмена
        </button>
      </div>

    </div>
  </div>

</template>

<script>

import GuiOrganizationSelect from "@/components/Widget/GuiOrganizationSelect";

export default {
  components: {GuiOrganizationSelect},
  data() {
    return {
      filter: {
        dateFrom: '',
        dateTo: '',
        organizationId: '',
      }
    }
  },
  methods: {
    openModal() {
      this.fancybox(this.$refs.modal)
    },
    download() {
      loadAsPostForm('/api/admin/report/payment-detail', {filter: this.filter})
    },
  },
}
</script>